

const DigiraatiRadioInput = ({
  field,
  form,
  name,
  value,
  children,
  ...props
}) => {


  return (
    <label className="radio-label">
      <div className="custom-radio-container">
        <input 
          type="radio"
          name={name}
          value={value}
          checked={field.value === value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          disabled={form.isSubmitting}
        />
        <div className="custom-radio">
          {children}
        </div>
      </div>

    </label>
  )

}

export default DigiraatiRadioInput;